import { Box, Paper, Typography } from "@material-ui/core";
import { useMemo } from "react";
import { useWeb3Connect } from "src/wallet-connection/context/we3-connect-context";

export default function AllowedNetworkWrapper({ allowedNetworks, helperText, children, ...props }) {
  const { chain } = useWeb3Connect();

  return (
    <Box {...props}>
      {useMemo(() => {
        if (allowedNetworks.includes(Number(chain.chainId))) return <>{children}</>;
        else
          return (
            <Paper>
              <Typography variant="h5">{helperText}</Typography>
            </Paper>
          );
      }, [chain.chainId, allowedNetworks, children])}
    </Box>
  );
}
